import { CORE_COLOR_MAP } from 'NewAngular/constants/core.constants';
export const COLOR_PICKER_OPTIONS_DEFAULT = Object.values(CORE_COLOR_MAP).map((colorObj) => colorObj.code);
